module.exports = __webpack_public_path__ + "img/p_12_s.7cda7ab6.png";